<script>
import comBeijing from './beijing/index.vue'
import comShanghai from './shanghai/index.vue'
import comGuangzhou from './guangzhou/index.vue'
import comShenzhen from './shenzhen/index.vue'
export default {
  components: {
    comBeijing,
    comShanghai,
    comGuangzhou,
    comShenzhen
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return { version: 'beijing' }
      }
    }
  },
  render () {
    const Tag = `com-${this.data.version}`
    return (<Tag></Tag>)
  }
}

</script>
